import "./apiUrls-CJS1Qk_E.js";
//#region src/generated/types.gen.ts
var e = {
	ORDER_MANAGEMENT: "ORDER_MANAGEMENT",
	LEGACY_ORDER_MANAGEMENT: "LEGACY_ORDER_MANAGEMENT",
	AUTO_ORDER_IMPORT: "AUTO_ORDER_IMPORT",
	BOL_DOT_COM_VVB_SHIPMENTS: "BOL_DOT_COM_VVB_SHIPMENTS",
	CUSTOM_CONTRACTS: "CUSTOM_CONTRACTS",
	DIRECT_PRINTING: "DIRECT_PRINTING",
	DISABLE_LABEL_HEADLINE: "DISABLE_LABEL_HEADLINE",
	EXTENDED_SHIPPING_RULES: "EXTENDED_SHIPPING_RULES",
	NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP: "NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP",
	ORDER_INVOICE: "ORDER_INVOICE",
	ORDER_NOTES: "ORDER_NOTES",
	ORDER_PICKLIST: "ORDER_PICKLIST",
	RETURN_LINK_ON_PACKING_SLIP: "RETURN_LINK_ON_PACKING_SLIP",
	SAVE_ORDER_SORTING_SETTING: "SAVE_ORDER_SORTING_SETTING",
	SCAN_MODE: "SCAN_MODE",
	SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK: "SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK",
	SHIPMENT_BULK_EDITS: "SHIPMENT_BULK_EDITS",
	SHIPMENT_DISCOUNT: "SHIPMENT_DISCOUNT",
	SHOP_LOGO_ON_PACKING_SLIP: "SHOP_LOGO_ON_PACKING_SLIP",
	TIER1_ANALYTICS: "TIER1_ANALYTICS",
	TIER2_ANALYTICS: "TIER2_ANALYTICS",
	TIER3_ANALYTICS: "TIER3_ANALYTICS",
	TIER4_ANALYTICS: "TIER4_ANALYTICS",
	TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS: "TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS",
	UNLIMITED_SHIPMENTS_PER_ORDER_LINE: "UNLIMITED_SHIPMENTS_PER_ORDER_LINE",
	UNLIMITED_SHIPPING_RULES: "UNLIMITED_SHIPPING_RULES"
}, t = { VASCO: "VASCO" }, n = {
	MYPARCEL_BE: "MYPARCEL_BE",
	MYPARCEL_NL: "MYPARCEL_NL",
	MYPARCEL_IT: "MYPARCEL_IT"
}, r = { SHOP_DEFAULT: "SHOP_DEFAULT" }, i = {
	ADMIN_CS: "ADMIN_CS",
	ADMIN_CS_ADVANCED: "ADMIN_CS_ADVANCED",
	ADMIN_FINANCE: "ADMIN_FINANCE",
	ADMIN_IT_SUPPORT: "ADMIN_IT_SUPPORT",
	ADMIN_SALES: "ADMIN_SALES",
	ADMIN_SUPER: "ADMIN_SUPER",
	CUSTOMER_ADMIN: "CUSTOMER_ADMIN",
	CUSTOMER_FINANCIAL: "CUSTOMER_FINANCIAL",
	CUSTOMER_FUNCTIONAL_MANAGER: "CUSTOMER_FUNCTIONAL_MANAGER",
	CUSTOMER_MAIN: "CUSTOMER_MAIN",
	CUSTOMER_MARKETING: "CUSTOMER_MARKETING",
	CUSTOMER_SERVICE: "CUSTOMER_SERVICE",
	CUSTOMER_SUB: "CUSTOMER_SUB",
	CUSTOMER_WAREHOUSE: "CUSTOMER_WAREHOUSE"
};
//#endregion
export { i as a, r as i, t as n, n as r, e as t };
